import MarketingLayout from "features/marketing/components/layout/MarketingLayout";

export default function LandingPageWrapper() {
    return (
        <MarketingLayout />
    )
}